import { useQuery } from "@tanstack/react-query";
import { getOtManageList } from "apis/staff/class_manage_api";
import { generateObjectZeroId, simpleAlert } from "components/CommonLib/CommonLib";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { otSearchParamInit } from "../Module/reducers/ot_manage_search_param";
import { useClassManageStore } from "../modules/store/classManageState";
import OtSearchCard from "./OtSearchCard";
import OtSearchResult from "./OtSearchResult";

const OtListView = ({ onClickOpenModal, branchInfo }) => {
  const storesDispatch = useDispatch();
  const [searchParam, setSearchParam] = useState(_.cloneDeep(otSearchParamInit));
  const [searchResult, setSearchResult] = useState([]);
  const [statusType, setStatusType] = useState("");
  const [curPage, setCurPage] = useState();
  const [totalPage, setTotalPage] = useState(0);
  const [phone, setPhone] = useState({
    p1: "",
    p2: "",
    p3: "",
  });
  const STATUS_DATA = ["수강", "연기", "대기", "소진완료", "만료"];
  // 전역 상태 관리
  const { setClassManageLoading: setLoading } = useClassManageStore();
  // API 상태 관리
  const [isGetOtManageList, setIsGetOtManageList] = useState(false);
  const queryData = { page: curPage, searchParam: searchParam };

  // [GET] OT 수업 관리 리스트
  const { data: otManageList } = useQuery({
    queryKey: ["otClassManage", queryData],
    queryFn: () => getOtManageList(queryData),
    enabled: isGetOtManageList,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setIsGetOtManageList(false);
      setLoading(false);
    },
  });

  const resetSearchParam = () => {
    setSearchParam(_.cloneDeep(otSearchParamInit));
    setPhone({ p1: "", p2: "", p3: "" });
    // 초기화 시 지점 첫번째 값 세팅
    if (branchInfo.branch_list[0]) {
      setSearchParam((prev) => {
        return { ...prev, branch_info: branchInfo.branch_list[0] };
      });
    }
  };

  const searchValidation = () => {
    // 전화번호 중간 자리 미입력 시 alert 띄움
    if (searchParam.member_base.phone === "err") {
      simpleAlert(storesDispatch, "알림", "전화번호 검색 조건이 잘못되었습니다.");
      return false;
    }

    if (searchParam.staff_text_name || searchParam.ot_info.class_status) {
      if (searchParam.ot_info.is_assigned !== "배정") {
        simpleAlert(storesDispatch, "알림", "배정 상태를 선택해주세요.");
        return false;
      } else if (
        !searchParam.branch_info.branch_id ||
        searchParam.branch_info.branch_id === generateObjectZeroId()
      ) {
        simpleAlert(storesDispatch, "알림", "지점을 선택해주세요.");
        return false;
      }
    }
    // OT 상태 옵션 선택 하나도 안했으면 자동으로 전체 복구
    if (searchParam.ot_info.root_status.length === 0) {
      searchParam.ot_info.root_status = [...STATUS_DATA];
    }

    return true;
  };

  //검색 POST
  const onClickSearch = async (page) => {
    if (!searchValidation()) {
      return;
    }
    setCurPage(page);
    setStatusType(searchParam.ot_info.is_assigned);
    setLoading(true);
    setIsGetOtManageList(true);
  };

  //테이블 다시 갱신
  const refreshTable = () => {
    onClickSearch(1);
  };

  // API 받아온 데이터 세팅
  useEffect(() => {
    // OT 수업관리 데이터
    if (otManageList) {
      setSearchResult(otManageList.data.data);
      setTotalPage(otManageList.data.total_page);
    }
  }, [otManageList]);

  // 페이지 진입 시 검색
  useEffect(() => {
    onClickSearch(1);
  }, []);

  return (
    <div>
      <SearchCard
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        resetSearchParam={resetSearchParam}
        otBranch={branchInfo}
        phone={phone}
        onClickSearch={onClickSearch}
        statusData={STATUS_DATA}
      />
      <SearchResultCard
        searchResult={searchResult}
        curPage={curPage}
        onClickSearch={onClickSearch}
        totalPage={totalPage}
        statusType={statusType}
        onClickOpenModal={onClickOpenModal}
        refreshTable={refreshTable}
      />
    </div>
  );
};
export default OtListView;

const SearchCard = ({
  searchParam,
  setSearchParam,
  resetSearchParam,
  otBranch,
  phone,
  onClickSearch,
  statusData,
}) => {
  return (
    <OtSearchCard
      searchParam={searchParam}
      setSearchParam={setSearchParam}
      resetSearchParam={resetSearchParam}
      otBranch={otBranch}
      phone={phone}
      onClickSearch={onClickSearch}
      statusData={statusData}
    />
  );
};

const SearchResultCard = ({
  searchResult,
  statusType,
  curPage,
  onClickSearch,
  totalPage,
  onClickOpenModal,
  refreshTable,
}) => {
  return (
    <OtSearchResult
      searchResult={searchResult}
      curPage={curPage}
      onClickSearch={onClickSearch}
      totalPage={totalPage}
      statusType={statusType}
      onClickOpenModal={onClickOpenModal}
      refreshTable={refreshTable}
    />
  );
};
